import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

var O2Button = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(O2Button, _React$PureComponent);

  function O2Button(props) {
    var _this;

    _this = _React$PureComponent.call(this, props) || this;
    _this.onClick = _this.onClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = O2Button.prototype;

  _proto.onClick = function onClick(e) {
    if (this.props.disabled) {
      e.preventDefault();
      return;
    }

    if (this.props.onClick) {
      this.props.onClick(e);
    }
  };

  _proto.textContent = function textContent(text) {
    return /*#__PURE__*/React.createElement("span", {
      className: "o2-btn__text"
    }, text);
  };

  _proto.iconContent = function iconContent(icon) {
    return /*#__PURE__*/React.createElement("span", {
      className: 'o2-icon o2-icon--' + icon
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        size = _this$props.size,
        fullWidth = _this$props.fullWidth,
        color = _this$props.color,
        icon = _this$props.icon,
        iconRight = _this$props.iconRight,
        indentLeft = _this$props.indentLeft,
        indentRight = _this$props.indentRight,
        indentTop = _this$props.indentTop,
        indentBottom = _this$props.indentBottom,
        firstLink = _this$props.firstLink,
        disabled = _this$props.disabled,
        spinner = _this$props.spinner,
        loading = _this$props.loading,
        form = _this$props.form,
        Tag = _this$props.tag,
        attributes = _objectWithoutPropertiesLoose(_this$props, ["children", "className", "size", "fullWidth", "color", "icon", "iconRight", "indentLeft", "indentRight", "indentTop", "indentBottom", "firstLink", "disabled", "spinner", "loading", "form", "tag"]);

    var iconClass = '';

    if (icon) {
      if (children && typeof children !== 'string') {
        throw new Error('If icon property is specified, children must be string');
      }

      iconClass = children ? iconRight ? 'o2-btn--icon-combined-right' : 'o2-btn--icon-combined' : 'o2-btn--icon';
    } else if ( /*#__PURE__*/React.isValidElement(children) && children.type.name === 'O2Icon') {
      iconClass = 'o2-btn--icon';
    } else if (Array.isArray(children)) {
      if ( /*#__PURE__*/React.isValidElement(children[0]) && children[0].type.name === 'O2Icon') {
        iconClass = 'o2-btn--icon-combined';
      } else if ( /*#__PURE__*/React.isValidElement(children[children.length - 1]) && children[children.length - 1].type.name === 'O2Icon') {
        iconClass = 'o2-btn--icon-combined-right';
      }
    } // We need to preserve fullWidth's backwards compatibility with bool, therefore fullWidth's not just enum.


    var widthClass = '';
    if (fullWidth === 'xs') widthClass = 'o2-btn--full-width-xs';else if (fullWidth === true) widthClass = 'o2-btn--full-width';
    var classes = classNames(className, 'o2-btn', size ? "o2-btn--" + size : false, color ? "o2-btn--" + color : false, iconClass, widthClass, loading ? "o2-btn--loading-" + loading : false, form ? "o2-btn--form-" + form : false, {
      'o2-btn--full-width': fullWidth,
      'o2-btn--indent-left': indentLeft,
      'o2-btn--indent-right': indentRight,
      'o2-btn--indent-top': indentTop,
      'o2-btn--indent-bottom': indentBottom,
      'o2-btn--first-link': firstLink,
      'o2-btn--disabled': disabled,
      'o2-btn--spinner': spinner
    });

    if (attributes.href && Tag === 'button') {
      Tag = 'a';
    }

    if (form && Tag === 'button') {
      Tag = 'div';
    }

    var content;

    if (icon && children) {
      content = iconRight ? /*#__PURE__*/React.createElement(React.Fragment, null, this.textContent(children), this.iconContent(icon)) : /*#__PURE__*/React.createElement(React.Fragment, null, this.iconContent(icon), this.textContent(children));
    } else if (icon) {
      content = this.iconContent(icon);
    } else if (typeof children === 'string') {
      content = this.textContent(children);
    } else {
      content = children;
    }

    return /*#__PURE__*/React.createElement(Tag, _extends({
      type: Tag === 'button' && attributes.onClick ? 'button' : undefined
    }, attributes, {
      className: classes,
      onClick: this.onClick
    }), content);
  };

  return O2Button;
}(React.PureComponent);

O2Button.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  tag: PropTypes.string,
  color: PropTypes.oneOf(["primary", "important", "transparent", "internal", "internal-alt", "positive"]),
  onClick: PropTypes.func,
  size: PropTypes.oneOf(['big', 'small', 'small-sm']),
  fullWidth: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['xs'])]),
  icon: PropTypes.string,
  iconRight: PropTypes.bool,
  indentLeft: PropTypes.bool,
  indentRight: PropTypes.bool,
  indentTop: PropTypes.bool,
  indentBottom: PropTypes.bool,
  firstLink: PropTypes.bool,
  disabled: PropTypes.bool,
  spinner: PropTypes.bool,
  loading: PropTypes.oneOf(['left', 'right', 'center']),
  form: PropTypes.oneOf(['addon', 'addon-plus', 'over-inner'])
};
O2Button.defaultProps = {
  tag: 'button'
};
O2Button.displayName = "O2Button";
export default O2Button;